import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class ResultsRedirect extends Component {
    componentDidMount() {
        const { location, history } = this.props;
        const searchParams = new URLSearchParams(location.search);

        if (!searchParams.has('searched')) {
            searchParams.set('searched', '1');
        }

        history.replace({
            pathname: '/',
            search: searchParams.toString()
        });
    }

    render() {
        return null;
    }
}

export default withRouter(ResultsRedirect);


// WEBPACK FOOTER //
// ./src/components/ResultsRedirect/index.js